import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user } = useAuth();

    if (user === undefined) {
        return (
            <div className="min-h-[80vh] flex items-center justify-center text-slate-400">
                <Loader2 className="w-6 h-6 animate-spin mr-3 text-blue-400" />
                Verifying session…
            </div>
        );
    }
    if (!user) return <Navigate to="/portal/login" replace />;
    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/portal" replace />;
    }
    return children;
}
